import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {HelperService} from "../../lib/helper.service";
import {HttpClient} from "@angular/common/http";
import {ChartParams} from "../../views/chart/chart.component";
import {ModalService} from "app/views/modal/base_modal.component";
import { BillingService2 } from "../billing.service";
import { ITotals } from "../../models/responce_result.model";

interface IUberTotal extends ITotals {
	totalRec: number;
	totalPaidRec: number;
	totalFailRec: number;
	money: number;
}

@Component({
	selector: 'uber',
	templateUrl: './uber.component.html'
})
export class UberComponent extends BaseComponent {
	chart = new ChartParams();
	stats = [];
	
	money: any = {};
	
	loader: boolean = false;
	
	currentPage: number = 1;
	
	totalRec: number = 0;
	totalPaidRec: number = 0;
	totalFailRec: number = 0;
	
	addFilterParams = {
		isBilling: true,
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated'],
	};

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
	}

	async getData() {
		await this.getChart();
		await this.getTotal();
		await this.getStats();
	}
	
	async getChart() {
		const { charts } = await this.service2.uber.chart(this.filter.filterParams).toPromise();
		this.chart.data = charts;
	}
	
	async getTotal() {
		const {
			totalRec, totalPaidRec, totalFailRec,
			money,
		} = await this.service2.uber.total<IUberTotal>(this.filter.filterParams).toPromise();
		
		this.totalRec     = totalRec;
		this.totalPaidRec = totalPaidRec;
		this.totalFailRec = totalFailRec;
		this.money        = money;
	}
	
	async getStats() {
		this.loader = true;
		
		const { stats } = await this.service2.uber.stats(
			{ ...this.filter.filterParams, page: this.currentPage }
		).toPromise();
		this.stats = stats;
		
		this.loader = false;
	}
	
	async onPageChange() {
		await this.getStats();
	}
}
